import React, { useState } from 'react'

const FilterSearch = ({ state, setState, label_text, placeholder,type }) => {

    const handleKeyDown = (e) => {
        if (type === "number" && e.key === '-') {
            e.preventDefault();
        }
    };
    const handleChange = (e) => {
        setState(e.target.value)
    }

    return (
        <>
            <div>
                <div className="relative block w-full group">
                    <label
                        htmlFor={label_text}
                        className="text-xs font-medium mb-1 block"
                    >
                        {label_text}
                    </label>
                    <input
                        type={type ? type : "text"}
                        min={0}
                        name={label_text}
                        id={label_text}
                        placeholder={placeholder ? placeholder : ""}
                        className={`resize-none h-[48px] !rounded-[10px] disabled:bg-gray-100 disabled:cursor-not-allowed input-text ${state && "!border-primary"}`}
                        value={state}
                        onChange={handleChange}
                        onKeyDown={handleKeyDown}
                    />

                </div>
            </div>
        </>
    )
}

export default FilterSearch